import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';

export function uploadFilesValidation(
  selectedEntityOption: string,
  alertHandlerService: AlertHandlerService,
  files: File[],
) {
  switch (selectedEntityOption) {
    case 'bulk_payments':
      return checkValidationForBulkPayment(files, alertHandlerService);
    case 'test':
      return false;
    default:
      return true;
  }
}

export function checkValidationForBulkPayment(
  files: File[],
  alertHandlerService: AlertHandlerService,
): Promise<boolean> {
  return new Promise<boolean>((resolve) => {
    if (files[0].size > 2e6) {
      alertHandlerService.showAlertFn(
        'error',
        'The CSV file cannot exceed 2MB (TBD). Please ensure you are using our template.',
        'File size exceeds the limit.',
      );
      resolve(false);
    } else if (files[0].type !== 'text/csv') {
      alertHandlerService.showAlertFn(
        'error',
        'The document should be .csv format. Please ensure you are using our template.',
        'File format not supported!',
      );
      resolve(false);
    } else {
      const reader: FileReader = new FileReader();
      reader.readAsText(files[0]);

      reader.onload = (e: any) => {
        const csv: string = e.target.result;
        const val = parseCsv(csv, alertHandlerService);
        resolve(val);
      };

      reader.onerror = (e: any) => {
        console.error('File reading error:', e);
      };
    }
  });
}

export function parseCsv(csv: string, alertHandlerService: AlertHandlerService): boolean {
  const rows: string[] = csv.split('\n');
  const csvData: any[] = [];
  for (const element of rows) {
    const row: string[] = element.split(',');
    csvData.push(row);
  }
  const staticCSVHeader: string[] = [
    'Country',
    'Currency',
    'Full Name / Org. Name',
    'Type(Personal/Business)',
    'Address line 1 (Optional)',
    'Address line 2 (Optional)',
    'State  (Optional)',
    'City  (Optional)',
    'Post Code  (Optional)',
    'Amount',
    'Schedule Payment(DD/MM/YYYY)',
    'Payment Reference',
    'Payment Reason (Payment for goods and services / Direct capital investment / Salary/Payroll / Refund / Loan / Repayment of loan / Merchant Settlement / Intercompany/group transfer / Tax Settlement / Expenses / Other / Property purchase / Mortage repayment)',
  ];
  const headerRow = csvData[0].map((header: string) => header.trim());
  const mandatoryHeadersFromCsv = headerRow.filter((header: string) => staticCSVHeader.includes(header));
  // Check if mandatory headers match
  const mandatoryHeadersMatch = checkArraysEquality(mandatoryHeadersFromCsv, staticCSVHeader);

  if (!mandatoryHeadersMatch) {
    alertHandlerService.showAlertFn(
      'error',
      'Please try again later. Please ensure you are using our template.',
      'Error uploading document!',
    );
    return false;
  } else {
    return true;
  }
}

export function checkArraysEquality(a: Array<any>, b: Array<any>): boolean {
  if (a.length !== b.length) {
    return false;
  }
  return a.every((value, index) => {
    const aValue = value.trim().toLowerCase();
    const bValue = b[index].trim().toLowerCase();
    return aValue === bValue;
  });
}

export function getFormActionType(selectedEntityOption: string) {
  switch (selectedEntityOption) {
    case 'bulk_payments':
      return FormActionTypeEnum.BULK_PAYMENTS;
    case 'test':
      return FormActionTypeEnum.CUSTOM_QUESTION;
    default:
      return FormActionTypeEnum.CUSTOM_QUESTION;
  }
}
